import SDKMessageBus from '../utility/message-bus';
import { debounceTime } from 'rxjs/operators';
import { OutletInfo } from '../types/index';
import { Maybe } from 'maybe-not';

export interface ScrollData {
    scrollY?: number;
    innerHeight?: number;
    top?: number;
    bottom?: number;
}

export default function platformScrollChanged(
    messageBus: SDKMessageBus,
    teardowns: (() => void)[],
    platformCapabilities: Set<string>,
    moduleId: string
) {
    let outletInfo: OutletInfo;

    if (!platformCapabilities.has('platformScrollChanged')) {
        return;
    }

    return function platformScrollChanged(
        callback: (scrollData: ScrollData & ClientRect) => void
    ): () => void {
        const getInfo = function() {
            return messageBus
                .sendRequest<OutletInfo>(
                    'requestOutletInfo',
                    Maybe.just(JSON.stringify({ moduleId }))
                )
                .then(response => {
                    if (response?.value) {
                        outletInfo = response.value;
                    }
                });
        };

        Promise.all([
            getInfo(),
            messageBus.sendRequest<ScrollData>('getPlatformScroll', Maybe.nothing())
        ]).then(([, { value: initialScrollData }]) => {
            callback({ ...initialScrollData, ...outletInfo });
        });

        const infoInterval = setInterval(getInfo, 1000);

        const sub = messageBus
            .onBroadcast<ScrollData>(`platformScrollChanged`)
            .pipe(debounceTime(16))
            .subscribe(message => {
                if (outletInfo) {
                    callback({ ...message.value, ...outletInfo });
                }
            });
        const unsub = () => {
            clearInterval(infoInterval);
            sub.unsubscribe();
        };
        teardowns.push(unsub);

        return unsub;
    };
}
